import React,{ useState,useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import logo from "../../assets/appLogo.png"
import showIcon from '../../assets/hideIcon.png';
import closeIcon from '../../assets/showIcon.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { updatePassword } from '../services/operations/authAPI';
import {message} from '../messages/Message'
import Loader from '../Loader/Loader';

const schema = yup.object().shape({
  password: yup.string()
    .required(message.passwordRequiredMessage)
    .min(8, message.passwordMinMessage)
    .matches(
      /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w])[A-Za-z\d\W_]{8,}$/,
      message.passwordMatchMessage
    )
});

const TeamRegister = () => {
    const { register, handleSubmit, watch, setValue, formState: { errors } } = useForm({
      resolver: yupResolver(schema),
      });

    const [email, setEmail] = useState('');
     const [showPasswordToggle, setShowPasswordToggle] = useState(false);
    const location=useLocation();
    const navigate=useNavigate();
    const dispatch=useDispatch();
    const loading=useSelector((state)=>state.auth.loading)

    const name = watch('name');
  const password = watch('password');

    const isFormValid = password &&  Object.keys(errors).length === 0;


    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const base64Param = params.get('data');
      const emailFromParams = base64Param ? atob(base64Param) : '';
    
      if (!emailFromParams) {
        navigate('/');
      } else {
        setEmail(emailFromParams); 
      }
    }, [location, navigate]);
    

      const togglePasswordVisibility = () => {
        setShowPasswordToggle(prevState => !prevState);
      };

       const onSubmit = async (data) => {

         const encodedPassword = btoa(data.password);
          const payload = {
           // name: data.name,
            email: email,
            password: encodedPassword,
          };
          await dispatch(updatePassword(payload,navigate))
        };


  return (
    <div className='registration-started'>
      {loading && <Loader/>}
        <img src={logo} className='app-image' alt='app-logo' onClick={() => navigate('/')} />
      <div className='registration-form'>
        <h2 className='reg-heading'>GET STARTED</h2>
        <p className='reg-desc'>
          <span style={{ color: 'rgba(26, 76, 255, 1)', fontWeight: '700' }}>{email}</span><br />
          Thanks for accepting the invite. Please set your password to continue.
        </p>
        <form onSubmit={handleSubmit(onSubmit)} className='reg-form'>
          {/* <div className='register-form-group'>
            <fieldset className={`register-form-border ${errors.name ? 'input-error' : ''}`}>
              <legend>Your Name</legend>
              <input type='text' id='name' placeholder='Enter Name' className='register-form-input' {...register('name')} />
            </fieldset>
            {errors.name && <p className='error-message'>{errors.name.message}</p>}
          </div> */}
          <div className='register-form-group'>
            <fieldset className={`register-form-border ${errors.password ? 'input-error' : ''}`}>
              <legend>Set Password</legend>
              <input type={showPasswordToggle ? 'text' : 'password'} id='password' placeholder='Enter password' className='register-form-input' {...register('password')} />
              <span className="password-toggle-icon" onClick={togglePasswordVisibility} style={{ top: "20px", right: "20px" }}>
                <img src={showPasswordToggle ? showIcon : closeIcon} alt='toggle visibility' />
              </span>
            </fieldset>
            {errors.password && <p className='error-message'>{errors.password.message}</p>}
          </div>
          <button
            type='submit'
            className='button-theme registration-button'
            style={{
              backgroundColor: isFormValid ? 'rgba(143, 222, 204, 1)' : '',
              cursor: isFormValid  ? 'pointer' : 'not-allowed',
              width: '500px',
            }}
            disabled={!isFormValid}
          >
            Next
          </button>
        </form>
        </div>
    </div>
  )
}

export default TeamRegister